<template>
  <section class="self-service-landing-page" id="self-service-landing-page">
    <div class="bg-shape bg-shape-one"></div>
    <div class="bg-shape bg-shape-two"></div>

    <main class="admin-main auth-main">
      <div class="auth-shell">
        <header class="auth-hero">
          <p class="eyebrow">Secure Access</p>
          <h1>
            <i class="fe fe-shield m-r-10"></i>
            Self Service Verification
          </h1>
          <p class="subtitle">
            Choose who is accessing self service, then continue with the relevant verification flow.
          </p>
        </header>

        <section>
          <div class="container px-0">
            <div class="row justify-content-center">
              <div class="col-12">
                <div class="audience-switch m-b-30">
                  <button
                    type="button"
                    class="audience-switch__option"
                    @click="goToRaiseTicket"
                  >
                    <span class="audience-switch__title">Raise a Ticket</span>
                    <span class="audience-switch__text">Submit complaints, inquiries, etc.</span>
                  </button>

                  <button
                    type="button"
                    class="audience-switch__option"
                    @click="goToEnrollee"
                  >
                    <span class="audience-switch__title">Enrollee</span>
                    <span class="audience-switch__text">Use enrollee ID and OTP to continue.</span>
                  </button>

                  <button
                    type="button"
                    class="audience-switch__option"
                    @click="goToProvider"
                  >
                    <span class="audience-switch__title">Provider</span>
                    <span class="audience-switch__text">Open tools for request, verification, and code checks.</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  </section>
</template>

<script>
export default {
  methods: {
    goToRaiseTicket() {
      const agency = JSON.parse(localStorage.getItem("agency") || "null");
      const path = agency && agency.id ? `/raise-ticket/${agency.id}` : "/raise-ticket";
      this.$router.push(path);
    },
    goToEnrollee() {
      this.$router.push("/self-service-auth/enrollee");
    },
    goToProvider() {
      this.$router.push("/self-service-auth/provider");
    },
  },
};
</script>

<style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;700&display=swap");

  .self-service-landing-page {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    font-family: "Space Grotesk", sans-serif;
    background:
      radial-gradient(circle at 10% 15%, rgba(17, 105, 71, 0.15), transparent 45%),
      radial-gradient(circle at 90% 85%, rgba(0, 122, 204, 0.2), transparent 42%),
      linear-gradient(140deg, #f5f8f7 0%, #eef5ff 100%);
  }

  .auth-main {
    position: relative;
    z-index: 1;
    padding: 40px 20px;
  }

  .auth-shell {
    max-width: 1000px;
    margin: 0 auto;
  }

  .bg-shape {
    position: absolute;
    z-index: 0;
    border-radius: 50%;
    filter: blur(2px);
  }

  .bg-shape-one {
    top: -120px;
    right: -120px;
    width: 320px;
    height: 320px;
    background: rgba(0, 122, 204, 0.13);
  }

  .bg-shape-two {
    bottom: -100px;
    left: -100px;
    width: 280px;
    height: 280px;
    background: rgba(17, 105, 71, 0.16);
  }

  .auth-hero {
    text-align: center;
    margin-bottom: 24px;
  }

  .eyebrow {
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #116947;
    font-weight: 700;
    font-size: 0.75rem;
    margin-bottom: 8px;
  }

  .auth-hero h1 {
    margin: 0;
    font-size: clamp(1.7rem, 4vw, 2.4rem);
    line-height: 1.1;
    color: #102a43;
  }

  .subtitle {
    max-width: 620px;
    margin: 12px auto 0;
    color: #334e68;
    font-size: 1rem;
  }

  .audience-switch {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
  }

  .audience-switch__option {
    border: 1px solid rgba(16, 42, 67, 0.08);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.8);
    padding: 20px;
    text-align: left;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  }

  .audience-switch__option:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(16, 42, 67, 0.08);
    border-color: rgba(17, 105, 71, 0.5);
  }

  .audience-switch__title {
    display: block;
    font-weight: 700;
    color: #102a43;
    margin-bottom: 8px;
  }

  .audience-switch__text {
    display: block;
    color: #486581;
    font-size: 0.95rem;
  }

  @media (max-width: 640px) {
    .auth-main {
      padding: 24px 14px;
    }

    .audience-switch {
      grid-template-columns: 1fr;
    }
  }
</style>
